module.exports = __webpack_public_path__ + "994f03e007e93f19ba54a44572eb005c.svg";